/* eslint-disable no-prototype-builtins */
import React, { useState, useCallback, useEffect, useRef } from 'react'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { useDrag, useDrop } from 'react-dnd'

import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Collapse from '@mui/material/Collapse'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Link } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import SendIcon from '@mui/icons-material/Send'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'

import { ExpandMore } from '../../../../helpers/cardHelpers'
import { getPayload, getTokenFromLocalStorage, userIsAuthenticated } from '../../../../helpers/storage'
import { positionChangeHeightSm, positionChangeWidthSm, swipelyticsPink, swipelyticsTurquoise } from '../../../../helpers/variableDefaults'
import useWindowDimensions from '../../../../helpers/windowDimensions'
import { modifyInDatabase } from '../../../../helpers/modifyInDatabase'
import { dragAndDropIconElement } from '../../../../helpers/buttons'
import { standardErrorContainer } from '../../../../helpers/errors'

const EditHobbyItem = ({ hobbyItem, datingProfile, setDatingProfile, hobbyItemIndex, loading, tapDisabled, handleSelectItem }) => {
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // Payload
  const payload = getPayload()

  // Navigate
  const navigate = useNavigate()

  // Params
  const { estateId, personId } = useParams()

  // URL Path
  const urlPath = window.location.pathname

  // Tracks whether the card is expanded
  const [expanded, setExpanded] = useState(false)

  // Edit Item Error
  const [editItemError, setEditItemError] = useState(false)

  // Drag and Drop
  const nullRef = useRef(null) // Disable drag and drop on mobile
  const ref = useRef(null)

  // Executes the drag/drop for the heir draft planning
  const moveHobbyItem = (dragIndex, hoverIndex, datingProfile, setDatingProfile, modifyInDatabase) => {
    // console.log('dragIndex ->', dragIndex)
    // console.log('hoverIndex ->', hoverIndex)
    // console.log('prompt item ->', promptItem)

    const draggedHobbyItem = datingProfile.bio.hobbies[dragIndex]
    // console.log('draggedMediaItem ->', draggedMediaItem)

    const newHobbyArray = [ ...datingProfile.bio.hobbies ]
    // console.log('beginning ->', newHobbyArray)

    // Delete old item
    newHobbyArray.splice(dragIndex, 1)
    // console.log('after delete ->', newHobbyArray)

    // Add it at the hover index
    newHobbyArray.splice(hoverIndex, 0, draggedHobbyItem)
    // console.log('after add ->', newPromptArray)

    const newBioObj = { ...datingProfile.bio, hobbies: newHobbyArray }


    // Set State
    // console.log('before set ->', newBioObj)
    setDatingProfile({ ...datingProfile, bio: newBioObj })

  }

  // Drop Handler
  const [{ handlerId }, drop] = useDrop({
    
    // Component Type (lower case)
    accept: 'edithobbyitem',
    
    // Monitoring
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },

    // Hover Handler
    hover(item, monitor) {
      if (!ref.current) {
        return
      }
      // console.log('drop item ->', item)
      const dragIndex = item.hobbyItemIndex // Start index
      // console.log('dragIndex ->', dragIndex)
      const hoverIndex = hobbyItemIndex // Index that's being hovered over
      // console.log('hoverIndex ->', hoverIndex)
      // console.log('media length ->', datingProfile.media.length)

      // Don't replace items with themselves; don't place an image at an index below the length the prompt items array
      if (dragIndex === hoverIndex || hoverIndex >= (datingProfile.bio.hobbies.length) || hoverIndex < 0) {
        // console.log('out of scope')
        return
      }

      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect()
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      // Determine mouse position
      const clientOffset = monitor.getClientOffset()
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top

      // Time to actually perform the action
      console.log('moveHobbyItem should run')
      moveHobbyItem(dragIndex, hoverIndex, datingProfile, setDatingProfile, modifyInDatabase)

      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.hobbyItemIndex = hoverIndex
    },
  })

  // Drag Handler
  const [{ isDragging }, drag, preview] = useDrag({
    
    // Component Type (lower case)
    type: 'edithobbyitem',

    // Item properties to retrieve
    item: () => {
      // console.log('is dragging')
      return { hobbyItemIndex }
    },

    // Monitor
    collect: (monitor) => ({
      // console.log('is monitoring')
      isDragging: monitor.isDragging(),
    }),
  })

  // Combine it all — Set the drag and drop to the ref
  drag(drop(ref))


  return (
    <Box 
      ref={loading.hobbies ? nullRef : ref} // Drag/drop enabled
      onClick={(e) => handleSelectItem(e, hobbyItemIndex)}
      disabled={tapDisabled()}
      sx={{ 
        width: '100%',
        cursor: tapDisabled() ? '' : 'pointer',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', 
      }}
    >
      {/* Hobby */}
      <Typography
        sx={{
          px: 2, py: 1.5,
          width: '100%',
          // fontWeight: 'bold',
        }}
      >
        {datingProfile.bio.hobbies[hobbyItemIndex]}
      </Typography>
    </Box>
  )
}

export default EditHobbyItem